@use 'sass:map';
@use '../../variables' as *;
@use 'common/assets/scss/global' as *;
@import '@fortawesome/fontawesome-svg-core/styles.css';

@keyframes shimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}

.btn-secondary.circle.close {
  height: 48px;
  width: 48px;
  background-color: HEXToRGBA(var(--#{$prefix}body-bg), 0.6) !important;
  position: absolute;
  top: 10px;
  right: 15px;

  &:focus-visible {
    outline-offset: -1px;
  }

  @media (width >= map.get($grid-breakpoints, md)) {
    display: none;
  }
}

.notification-drawer {
  visibility: hidden;
  z-index: -1;
  position: fixed;
  top: $header-height;
  bottom: 0;
  right: 0;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  background-color: var(--#{$prefix}body-bg);
  box-shadow: var(--#{$prefix}shadow-strong) HEXToRGBA($black, 0.1);
  overflow: hidden auto;
  clip-path: inset(0 0 0 -32px);
  transform: translateX(320px + 32);
  transition:
    visibility 0.15s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);

  > ul {
    @include unstyled-list;
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding: 16px 0;

    > li {
      > h2 {
        padding-inline: 16px;
        margin-bottom: 8px;
        color: var(--#{$prefix}primary);

        &::first-letter {
          text-transform: capitalize;
        }
      }

      > ul {
        @include unstyled-list;
        display: flex;
        flex-direction: column;
        gap: 16px;

        > li {
          > .header {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 8px;
            padding-inline: 32px;
            margin-bottom: 8px;
            min-height: 34px;

            > .icon {
              flex: 0 0 auto;
              height: 24px;
              width: 24px;
              color: var(--#{$prefix}service);
            }

            > h3 {
              flex: 1 1 auto;
              margin-bottom: unset;
            }

            > button {
              flex: 0 0 auto;
              transition: opacity 0.15s ease-out;
            }

            @each $type, $values in $categories {
              @if $type == category-default {
                --#{$prefix}service: var(--#{$prefix}#{$type});
              } @else {
                &.#{$type} {
                  --#{$prefix}service: var(--#{$prefix}#{$type});
                }
              }
            }

            &.skeleton ::before {
              content: '';
              position: absolute;
              top: calc(50% - 20px / 2);
              left: 32px;
              z-index: -1;
              height: 20px;
              width: 120px;
              border-radius: 10px;
              background: linear-gradient(90deg, #e9e9e9 30%, #f6f6f6 50%, #e9e9e9 70%);
              background-size: 200% 100%;
              animation: shimmer 1.5s infinite linear;
            }
          }

          > ul {
            @include unstyled-list;
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding-inline: 16px;

            > li {
              position: relative;
              padding: 16px;
              border-radius: 10px;
              box-shadow: var(--#{$prefix}shadow-neutral) HEXToRGBA($black, 0.1);
              outline-color: transparent;
              transition:
                outline 0.15s ease-out,
                box-shadow 0.15s ease-out;

              > .header {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-right: 22px;
                margin-bottom: 8px;

                > .icon {
                  font-size: var(--#{$prefix}font-size-lg);
                }

                > h4 {
                  margin-bottom: unset;

                  > a {
                    @include unstyled-link;

                    &::after {
                      content: '';
                      position: absolute;
                      inset: 0;
                    }

                    &:focus-visible {
                      outline: none;
                    }
                  }
                }
              }

              > .message {
                margin-bottom: 16px;
                word-wrap: break-word;
                white-space-collapse: break-spaces;
              }

              > .createdAt {
                position: absolute;
                bottom: 10px;
                right: 10px;
                color: var(--#{$prefix}basic-black-lighter);
                font-size: var(--#{$prefix}font-size-xs);
              }

              > button {
                position: absolute;
                top: 4px;
                right: 4px;
                transition: opacity 0.15s ease-out;

                &:not(:hover, :focus-visible) {
                  background-color: unset;
                }
              }

              &:hover {
                box-shadow: var(--#{$prefix}shadow-hover) HEXToRGBA(var(--#{$prefix}primary), 0.2);
              }

              &:has(> .header > h4 > a:hover, > .header > h4 > a:focus-visible) {
                outline: 2px solid var(--#{$prefix}primary);
                outline-offset: -2px;
                box-shadow: var(--#{$prefix}shadow-hover) HEXToRGBA(var(--#{$prefix}primary), 0.2);
              }

              &:hover,
              &:has(:focus-visible) {
                > button {
                  opacity: 1;
                }
              }
            }
          }

          &:hover,
          &:has(:focus-visible) {
            > .header > button {
              opacity: 1;
            }
          }
        }
      }
    }
  }

  > .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 16px;
    margin-top: 64px;

    > .icon {
      font-size: 38px;
      margin-bottom: 14px;
      opacity: 0.1;
    }

    > .text {
      display: flex;
      flex-direction: column;
      text-align: center;
      font-size: var(--recia-font-size-xs);

      > .large {
        font-size: var(--recia-font-size-sm);
        font-weight: bold;
        letter-spacing: -0.15px;
      }
    }
  }

  &.expended {
    visibility: visible;
    transform: translateX(0);
  }

  &:focus-visible {
    outline: 2px dotted var(--#{$prefix}primary);
    outline-offset: -2px;
    border-radius: 10px;
  }

  @media (hover: hover) and (pointer: fine) {
    > ul > li > ul > li {
      > .header > button {
        opacity: 0;
      }

      > ul > li {
        > button {
          opacity: 0;
        }
      }
    }
  }
}
